import { IconDataSource } from '@/components/Icon/IconDataSource';
import { IconLargeScreen } from '@/components/Icon/IconLargeScreen';
import { IconLogAccess } from '@/components/Icon/IconLogAccess';
import { IconLogRules } from '@/components/Icon/IconLogRules';
import { IconMonitorRules } from '@/components/Icon/IconMonitorRules';
import { SUB_CENTER } from '@/constants/subCenter';
import { GROUPS } from '@/service/apiConf';

export const getTenantMenu = (tenant, cluster) => {
  cluster = cluster || ':cluster';
  const consolePath = `/console/${tenant}/cluster/${cluster}`;
  const ai = `${consolePath}/${SUB_CENTER.AI}`;
  const app = `${consolePath}/${SUB_CENTER.APP}`;
  const charge = `${consolePath}/${SUB_CENTER.CHARGE}`;
  const ops = `${consolePath}/${SUB_CENTER.OPS}`;
  return [
    {
      // 控制台
      title: 'console',
      icon: 'icon-zuhuguanli',
      filter: 'TenantFilter',
      children: [
        // 算力中心（默认主视图，无独立 URL 前缀）
        {
          title: 'computeCenter',
          icon: 'icon-suanli',
          externalLink: true,
          fixBottom: true,
          centerKey: SUB_CENTER.COMPUTE,
          children: [
            {
              title: 'computeCenterOverview',
              icon: 'icon-gailan',
              path: `${consolePath}/overview`,
              isLeaf: true,
              permissionVisibleWithParent: true,
              viewAuth: [GROUPS.datacenter, 'compute-center/overview', 'get'],
            },
            // 制品中心
            {
              title: 'productsCatalogue',
              icon: 'icon-chanpin',
              children: [
                {
                  title: 'systemImagesNew',
                  icon: 'icon-jingxiang',
                  path: `/console/${tenant}/cluster/${cluster}/system-images`,
                  viewAuth: [GROUPS.image, 'system-images', 'list'],
                  // 制品中心-系统镜像仓库
                },
                {
                  title: 'drivers',
                  icon: 'icon-plug',
                  path: `/console/${tenant}/cluster/${cluster}/drivers`,
                  viewAuth: [GROUPS.image, 'drivers', 'list'],
                },
                {
                  title: 'runtime',
                  icon: 'icon-runtime',
                  path: `/console/${tenant}/cluster/${cluster}/runtime`,
                  viewAuth: [GROUPS.image, 'runtime', 'list'],
                },
                {
                  title: 'tool',
                  icon: 'icon-tool',
                  path: `/console/${tenant}/cluster/${cluster}/tool`,
                  viewAuth: [GROUPS.image, 'tool', 'list'],
                },
              ],
            },
            {
              title: 'instances',
              icon: 'icon-Vastack',
              children: [
                {
                  title: 'containerInstances',
                  icon: 'icon-rongqi',
                  path: `/console/${tenant}/cluster/${cluster}/container/instance`,
                  viewAuth: [GROUPS.computing, 'containerinstances', 'list'],
                },
                {
                  title: 'VMInstances',
                  icon: 'icon-jiqun',
                  path: `/console/${tenant}/cluster/${cluster}/cloud/instance`,
                  viewAuth: [GROUPS.computing, 'virtualmachines', 'list'],
                },
                {
                  title: 'elasticBareMetalInstance',
                  path: `/console/${tenant}/cluster/${cluster}/ebm/instance`,
                  icon: 'icon-luojinshu1',
                  viewAuth: [GROUPS.computing, 'elasticbaremetals', 'list'],
                },
                {
                  title: 'bareMetalInstances',
                  path: `/console/${tenant}/cluster/${cluster}/bare-metal/instance`,
                  icon: 'icon-Vastack',
                  viewAuth: [GROUPS.computing, 'instances', 'list'],
                },
                {
                  title: 'containerCluster',
                  path: `/console/${tenant}/cluster/${cluster}/clusters/biz`,
                  icon: 'icon-jiqun',
                  viewAuth: [GROUPS.clusterScheduler, 'clusters', 'list'],
                },
              ],
            },
            {
              title: 'networkSecurity',
              icon: 'icon-wangluo',
              children: [
                {
                  title: 'vpc',
                  path: `/console/${tenant}/cluster/${cluster}/vpc`,
                  icon: 'icon-VPC',
                  viewAuth: [GROUPS.network, 'vpcs', 'list'],
                },
                {
                  title: 'securityGroup',
                  path: `/console/${tenant}/cluster/${cluster}/safegroup`,
                  icon: 'icon-a-baomizidianmian',
                  viewAuth: [GROUPS.network, 'securitygroups', 'list'],
                },
                {
                  title: 'eip',
                  path: `/console/${tenant}/cluster/${cluster}/eip`,
                  icon: 'icon-a-danxinggongwangIPEIP',
                  viewAuth: [GROUPS.network, 'eips', 'list'],
                },
              ],
            },
            // 容器存储
            {
              title: 'intelligentStorage',
              icon: 'icon-cunchu',
              children: [
                {
                  title: 'cloudHostCloudDisk',
                  path: `/console/${tenant}/cluster/${cluster}/vm/cloud-disk`,
                  icon: 'icon-yunzhuji',
                  viewAuth: [GROUPS.storageStack, 'volumes', 'list'], // 控制台-云主机-权限
                },
                {
                  title: 'persistentVolumes',
                  path: `/console/${tenant}/cluster/${cluster}/pvcs`,
                  icon: 'icon-juankuaizhaolei',
                  viewAuth: [GROUPS.persistentvolumeclaim, 'persistentvolumeclaims', 'list'],
                },
              ],
            },
          ],
        },

        // 模型中心（外链打开子中心）
        {
          title: 'aiCenter',
          icon: 'icon-model',
          externalLink: true,
          centerKey: SUB_CENTER.AI,
          fixBottom: true,
          children: [
            {
              title: 'aiOverview',
              icon: 'icon-gailan',
              path: `${ai}/overview`,
              viewAuth: [GROUPS.llmgw, 'llmgwoverview', 'get'],
            },
            {
              title: 'modelExperience',
              icon: 'icon-kongzhitai',
              children: [
                {
                  title: 'textModelExperience',
                  icon: 'icon-zhongduan',
                  path: `${ai}/model-center/model-experience/text`,
                  viewAuth: [GROUPS.llmgw, 'v1/models', 'get'],
                },
                {
                  title: 'audioModelExperience',
                  icon: 'icon-tongzhishezhi',
                  path: `${ai}/model-center/model-experience/audio`,
                  viewAuth: [GROUPS.llmgw, 'v1/models', 'get'],
                },
                {
                  title: 'visionModelExperience',
                  icon: 'icon-VideoCamera',
                  path: `${ai}/model-center/model-experience/vision`,
                  viewAuth: [GROUPS.llmgw, 'v1/models', 'get'],
                },
                {
                  title: 'embeddingModelExperience',
                  icon: 'icon-Data',
                  path: `${ai}/model-center/model-experience/embedding`,
                  viewAuth: [GROUPS.llmgw, 'v1/models', 'get'],
                },
              ],
            },
            {
              title: 'modelService',
              icon: 'icon-moxingshili',
              children: [
                {
                  title: 'inferenceFramework',
                  icon: 'icon-infer',
                  path: `${ai}/model-center/inference-framework`,
                  viewAuth: [GROUPS.image, 'inference-framework', 'list'],
                },

                {
                  title: 'modelPlaza',
                  icon: 'icon-model',
                  path: `${ai}/model-center/model-plaza`,
                  isLeaf: true,
                  viewAuth: [GROUPS.ophub, 'artifacts', 'list'],
                },
                {
                  title: 'modelInstance',
                  icon: 'icon-moxingshili',
                  path: `${ai}/model-center/model-instance`,
                  isLeaf: true,
                  viewAuth: [GROUPS.inferenceMaas, 'modelinstances', 'list'],
                },
                {
                  title: 'modelSubscription',
                  icon: 'icon-dingyue',
                  path: `${ai}/model-center/model-subscription`,
                  viewAuth: [GROUPS.llmgw, 'llmgwmodelbindings', 'list'],
                },
              ],
            },
            {
              title: 'modelTraining',
              icon: 'icon-Data',
              children: [
                {
                  title: 'trainingTask',
                  icon: 'icon-rizhi',
                  path: `${ai}/model-center/training-task`,
                  isLeaf: true,
                  viewAuth: [GROUPS.trainingMaas, 'trainingtasks', 'list'],
                },
                {
                  title: 'trainingCluster',
                  icon: 'icon-jiqun',
                  path: `${ai}/model-center/training-cluster`,
                  isLeaf: true,
                  viewAuth: [GROUPS.trainingMaas, 'trainingclusters', 'list'],
                },
              ],
            },
            {
              title: 'securityGovernance',
              icon: 'icon-zhidu',
              children: [
                {
                  title: 'modelAuditLog',
                  icon: 'icon-rizhi',
                  path: `${ai}/model-center/audit-log`,
                  viewAuth: [GROUPS.llmgw, 'llmgwaudits', 'list'],
                },
              ],
            },
          ],
        },

        // 应用中心（外链打开子中心）
        {
          title: 'appCenter',
          icon: 'icon-ai-app',
          externalLink: true,
          fixBottom: true,
          centerKey: SUB_CENTER.APP,
          children: [
            {
              title: 'applicationMarket',
              children: [
                {
                  title: 'skillPlaza',
                  path: `${app}/skill-plaza`,
                  icon: 'icon-skills',
                  isLeaf: true,
                  viewAuth: [GROUPS.ophub, 'artifacts', 'list'],
                },
                {
                  title: 'appPlaza',
                  path: `${app}/app-plaza`,
                  icon: 'icon-ai-app',
                  isLeaf: true,
                  viewAuth: [GROUPS.ophub, 'artifacts', 'list'],
                },
              ],
            },
            {
              title: 'instanceManagement',
              children: [
                {
                  title: 'appInstance',
                  path: `${app}/app-instance`,
                  icon: 'icon-chanpinguanli',
                  isLeaf: true,
                  viewAuth: [GROUPS.maas, 'applicationinstances', 'list'],
                },
              ],
            },
          ],
        },

        // 费用中心（仅租户空间）
        {
          title: 'chargeCenter',
          /** 子菜单沿用迁移前的后台权限白名单前缀。 */
          permissionChildrenKey: 'console-computeCenter-chargeCenter',
          icon: 'icon-jifeiguanli',
          externalLink: true,
          fixBottom: true,
          centerKey: SUB_CENTER.CHARGE,
          children: [
            {
              title: 'consoleOverview',
              icon: 'icon-gailan',
              path: `${charge}/overview`,
              viewAuth: [GROUPS.ophub, 'cost-analysis', 'get'],
            },
            {
              title: 'orderManagement',
              icon: 'icon-dingdanguanli',
              path: `${charge}/orders`,
              viewAuth: [GROUPS.ophub, 'order-items', 'list'],
            },
            {
              title: 'billManagement1',
              icon: 'icon-jifeiguanli',
              path: `${charge}/bills`,
              viewAuth: [GROUPS.ophub, 'invoices', 'list'],
            },
            {
              title: 'rechargeRecords',
              path: `${charge}/recharge`,
              icon: 'icon-buchongjifei',
              viewAuth: [GROUPS.ophub, 'recharge-requests', 'list'],
            },
            {
              title: 'benefitsCenter',
              path: `${charge}/benefits-center`,
              icon: 'icon-youhuijuan',
              viewAuth: [GROUPS.ophub, 'user-coupons', 'list'],
            },
          ],
        },

        // 运维中心（外链打开子中心，租户无态势感知）
        {
          title: 'operations',
          icon: 'icon-yunweizhongxin3',
          externalLink: true,
          fixBottom: true,
          centerKey: SUB_CENTER.OPS,
          children: [
            {
              title: 'opsOverview',
              path: `${ops}/overview`,
              icon: 'icon-gailan',
              viewAuth: [GROUPS.monitor, 'alertoverview', 'list'],
            },
            {
              title: 'monitoring',
              icon: 'icon-yunweizhongxin3',
              children: [
                {
                  title: 'visualization',
                  path: `${ops}/monitor-center/largescreen-config`,
                  icon: IconLargeScreen,
                  viewAuth: [GROUPS.monitor, 'dashboards', 'list'],
                },
                {
                  title: 'metricsExplorer',
                  path: `${ops}/monitor-center/metric-query`,
                  icon: 'icon-zhibiao',
                  viewAuth: [GROUPS.monitor, 'explore', 'list'],
                },
                {
                  title: 'aiAlert',
                  path: `${ops}/monitor-center/rule-configuration`,
                  icon: IconMonitorRules,
                  viewAuth: [GROUPS.monitor, 'monitorrules', 'list'],
                },
                {
                  title: 'monitorAlertLogs',
                  path: `${ops}/alert-center/alert-monitor`,
                  icon: 'icon-gaojingjilu',
                  viewAuth: [GROUPS.monitor, 'alertrecords', 'list'],
                },
                {
                  title: 'monitoringIntegration',
                  path: `${ops}/monitor-center/data-access`,
                  icon: IconDataSource,
                  viewAuth: [GROUPS.monitor, 'datasources', 'list'],
                },
              ],
            },
            {
              title: 'logCenter',
              icon: 'icon-rizhizhongxin',
              children: [
                {
                  title: 'logIngestion',
                  path: `${ops}/log-center/log-access`,
                  icon: IconLogAccess,
                  viewAuth: [GROUPS.log, 'tables', 'list'],
                },
                {
                  title: 'logAIAlert',
                  path: `${ops}/log-center/log-rule`,
                  icon: IconLogRules,
                  viewAuth: [GROUPS.log, 'logrules', 'list'],
                },
                {
                  title: 'alertLogs',
                  path: `${ops}/alert-center/alert-log`,
                  icon: 'icon-gaojingjilu',
                  viewAuth: [GROUPS.log, 'logalertrecords', 'list'],
                },
              ],
            },
            {
              title: 'notificationSettings',
              icon: 'icon-tongzhishezhi',
              children: [
                {
                  title: 'notificationChannels',
                  path: `${ops}/alert-center/alert-medium`,
                  icon: 'icon-tongzhishezhi',
                  viewAuth: [GROUPS.alertmanager, 'alertmediums', 'list'],
                },
              ],
            },
          ],
        },
        {
          title: 'apiKeyManagement',
          icon: 'icon-api-key',
          path: `${consolePath}/model-center/api-key`,
          fixBottom: true,
          /** API Key 保持底部入口，并在 AI 与应用中心侧栏展示。 */
          onlyCenters: [SUB_CENTER.AI, SUB_CENTER.APP],
          viewAuth: [GROUPS.llmgw, 'llmgwapikeys', 'list'],
        },
        {
          title: 'members',
          path: `/console/${tenant}/cluster/${cluster}/members`,
          icon: 'icon-pingtaiyonghu',
          fixBottom: true,
          viewAuth: [GROUPS.iam, 'users', 'list'],
        },
        {
          title: 'rbac',
          path: `/console/${tenant}/cluster/${cluster}/roles`,
          icon: 'icon-pingtaijiaose',
          fixBottom: true,
          viewAuth: [GROUPS.iam, 'roles', 'list'],
        },
        {
          title: 'audit', //审计
          path: `/console/${tenant}/cluster/${cluster}/audit`,
          icon: 'icon-Outline',
          fixBottom: true,
          viewAuth: [GROUPS.iam, 'audits', 'list'],
        },
        {
          title: 'tenantSetting',
          path: `/console/${tenant}/cluster/${cluster}/setting`,
          icon: 'icon-Setting',
          fixBottom: true,
          viewAuth: [GROUPS.workspace, 'workspaces', 'update'],
        },
      ],
    },
  ];
};
